var RM = {}
window.RM = RM
export default RM